module.exports = __webpack_public_path__ + "img/award-1.695808e9.png";